import { ref } from 'vue'
import { defineStore } from 'pinia'
import request from '@u/request'

export const useUserAndCompanyInfosStore = defineStore('userAndCompanyInfo', () => {
  const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
  const companyInfo = ref(JSON.parse(sessionStorage.getItem('companyInfo')))
  const currencyList = [
    {
      region: 'CN',
      countryName: {
        cnName: '中国',
        enName: 'China',
      },
      languageName: {
        cnName: '中文',
        enName: 'Chinese',
      },
      currency: {
        symbol: '￥',
        code: 'CNY',
        cnName: '人民币',
        enName: 'Chinese Yuan',
      },
    },
    {
      region: 'SG',
      countryName: {
        cnName: '新加坡',
        enName: 'Singapore',
      },
      languageName: {
        cnName: '英文',
        enName: 'English',
      },
      currency: {
        symbol: '$',
        code: 'SGD',
        cnName: '新加坡元',
        enName: 'Singapore Dollar',
      },
    },
  ]
  const symbol = ref('￥')
  async function begin() {
    const o = await getUserAndCompanyInfo()
    userInfo.value = o.userInfo
    companyInfo.value = o.companyInfo
    const currency = o.companyInfo.localeCode || 'CN'
    symbol.value = currencyList.find((it) => it.region === currency).currency.symbol
  }
  if (companyInfo.value === null) {
    begin()
  }

  return {
    userInfo,
    companyInfo,
    symbol,
    async updateCompanyInfo() {
      const res = await getCompanyInfo(userInfo.value.companyId)
      if (res) {
        companyInfo.value = res
        sessionStorage.setItem('companyInfo', JSON.stringify(companyInfo.value))
      }
    },
  }
})

async function getUserInfo() {
  const res = await request.get('xspeed-edu/user/getUserInfo')
  return res?.data
}
async function getCompanyInfo(companyId) {
  const res = await request.get('xspeed-edu/white/getCompanyInfo', { companyId })
  return res?.data
}
async function getUserAndCompanyInfo() {
  const userInfo = await getUserInfo()
  let companyInfo = null
  if (userInfo?.companyId) {
    companyInfo = await getCompanyInfo(userInfo.companyId)
  }
  sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
  sessionStorage.setItem('companyInfo', JSON.stringify(companyInfo))
  return { userInfo, companyInfo }
}
